export function validated(data) {
  let res = true;
  const not_null = Object.keys(data).map((i) => {
    if (data[i] === "NA" || data[i] === "") {
      return false;
    }
    return true;
  });
  for (let i = 0; i < not_null.length; i++) {
    res = res && not_null[i];
  }

  //console.log(not_null);
  return res;
}


